import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "31"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#000",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", { d: "M21.324 11.383h-2.209V6.404C19.115 2.873 16.147 0 12.498 0S5.88 2.873 5.88 6.404v4.979H3.676C1.65 11.383 0 13.013 0 15.016v12.351C0 29.37 1.65 31 3.676 31h17.648C23.35 31 25 29.37 25 27.367V15.016c0-2.004-1.65-3.633-3.676-3.633M8.33 6.404c0-2.196 1.87-3.982 4.167-3.982s4.166 1.786 4.166 3.982v4.979H8.331zM22.55 27.367c0 .668-.55 1.211-1.225 1.211H3.676a1.22 1.22 0 0 1-1.225-1.21V15.015c0-.668.55-1.211 1.225-1.211h17.648a1.22 1.22 0 0 1 1.225 1.21z" }),
      _createElementVNode("path", { d: "M12.5 17.316c-1.252 0-2.267 1.003-2.267 2.24 0 .79.414 1.485 1.04 1.884v2.658c0 .668.548 1.21 1.225 1.21s1.225-.542 1.225-1.21v-2.656a2.23 2.23 0 0 0 1.044-1.885c0-1.238-1.015-2.24-2.267-2.24" })
    ], -1)
  ]))]))
}
export default { render: render }